import { NgModule } from "@angular/core";
import { SharedModule } from "../../shared/shared.module";
import { Common } from "./common/common";
import { HistorySignageComponent } from "./historysignage.component";

@NgModule({
    imports: [
        SharedModule,
        Common,
    ],
    declarations: [
        HistorySignageComponent,
    ],
})
export class HistorySignageModule { }
